import * as React from 'react';
import { cn } from '../lib/cn.js';

// `.bouton` du kit : une variante par classe, un état par attribut. `quiet` est le fantôme en
// encre discrète — l'action secondaire d'une ligne ou d'une barre (modifier, fermer, précédent).
type Variant = 'primary' | 'secondary' | 'ghost' | 'quiet' | 'danger' | 'success';
/** `small` est la taille dense du kit (bureau) ; `icon` est carré, `icon-small` carré et dense. */
type Size = 'default' | 'small' | 'icon' | 'icon-small';

const VARIANT: Record<Variant, string> = {
  primary: '',
  secondary: 'bouton-secondaire',
  ghost: 'bouton-fantome',
  quiet: 'bouton-discret',
  danger: 'bouton-danger',
  success: 'bouton-succes',
};

const SIZE: Record<Size, string> = {
  default: '',
  small: 'bouton-petit',
  icon: 'bouton-icone',
  'icon-small': 'bouton-icone bouton-petit',
};

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  /** Pose `aria-busy` : le kit remplace le libellé par une roue, le bouton garde sa largeur. */
  loading?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'default', loading = false, disabled, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn('bouton', VARIANT[variant], SIZE[size], className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    />
  )
);
Button.displayName = 'Button';
